import React from "react";

import { Content } from "src/components/AddPoshmarkExtensionDialog";

import type Step from "../Step";

interface WhatnotAddExtensionProps {
  onClose: () => void;
  onStepChange: (step: Step) => void;
  update?: boolean;
}

function WhatnotAddExtension({
  onClose,
  onStepChange,
  update,
}: WhatnotAddExtensionProps) {
  return <Content platform="Whatnot" update={update} onClose={onClose} />;
}

export default WhatnotAddExtension;
